import { type MutationError, trpc } from '@/shared/api';

interface UseDeletePrintMethodOptions {
  readonly onSuccess?: () => void;
}

/** 인쇄 방식 삭제 — 상품이 쓰고 있는 방식은 서버가 거부한다. */
export const useDeletePrintMethod = ({ onSuccess }: UseDeletePrintMethodOptions = {}) => {
  const mutation = trpc.productManagement.printMethods.delete.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    deletePrintMethod: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
